var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "l-product__row" },
    [
      _c(
        "div",
        { staticClass: "l-product__imgCol" },
        [
          _vm.selectedVariation && !_vm.showFullsize
            ? _c(
                "swiper",
                {
                  ref: "productSwiper",
                  staticClass: "swiper productSwiper",
                  attrs: { options: _vm.productSwiper },
                  on: { swiper: _vm.setSmallSwiper }
                },
                [
                  _vm._l(_vm.selectedVariation.slides, function(slide, index) {
                    return _c(
                      "swiper-slide",
                      {
                        key: index,
                        staticClass: "productSwiper-slide",
                        nativeOn: {
                          click: function($event) {
                            return _vm.maximise(index)
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: "placeholder",
                            srcset: slide.large,
                            alt: slide.alt
                          }
                        })
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "product-swiper-prev swiper-button-prev",
                      attrs: { slot: "button-prev" },
                      slot: "button-prev"
                    },
                    [_vm._t("prevbuttonsvg")],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "product-swiper-next swiper-button-next",
                      attrs: { slot: "button-next" },
                      slot: "button-next"
                    },
                    [_vm._t("nextbuttonsvg")],
                    2
                  )
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "product-swiper-pagination swiper-pagination",
            attrs: { slot: "pagination" },
            slot: "pagination"
          }),
          _vm._v(" "),
          _vm.selectedVariation && !_vm.showFullsize
            ? _c(
                "swiper",
                {
                  ref: "productThumbsSwiper",
                  staticClass: "swiper productThumbsSwiper",
                  attrs: { options: _vm.productThumbsSwiper }
                },
                _vm._l(_vm.selectedVariation.slides, function(thumb, index) {
                  return _c(
                    "swiper-slide",
                    { key: index, staticClass: "productThumbsSwiper-slide" },
                    [
                      _c("img", {
                        attrs: {
                          src: _vm.placeholder,
                          srcset: thumb.thumb,
                          alt: thumb.alt
                        }
                      })
                    ]
                  )
                }),
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "l-product__dataCol" },
        [
          _vm._t("info"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "l-product__addToCart" },
            [
              _c(
                "div",
                { staticClass: "l-product__variations" },
                _vm._l(_vm.variants, function(variant) {
                  return _c(
                    "div",
                    {
                      key: variant.id,
                      staticClass: "l-product__variations-item"
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedVariation,
                            expression: "selectedVariation"
                          }
                        ],
                        attrs: {
                          name: "purchasableId",
                          type: "radio",
                          id: "variant-" + variant.id
                        },
                        domProps: {
                          value: variant,
                          checked: _vm._q(_vm.selectedVariation, variant)
                        },
                        on: {
                          change: function($event) {
                            _vm.selectedVariation = variant
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "variant-" + variant.id } }, [
                        _c("img", { attrs: { src: variant.image.url } })
                      ])
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "l-product__selectedVariation" }, [
                _vm._v("\n        Variation: "),
                _c("span", [_vm._v(_vm._s(_vm.selectedVariation.title))])
              ]),
              _vm._v(" "),
              _vm.showPrice
                ? _c("div", {
                    staticClass: "l-product__price",
                    domProps: { innerHTML: _vm._s(_vm.selectedVariation.price) }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "form",
                { staticClass: "l-product__form" },
                [
                  _vm._t("form"),
                  _vm._v(" "),
                  _c("qty-spinner", {
                    attrs: {
                      min: _vm.spinnerMin,
                      value: _vm.spinnerMin,
                      step: 1
                    },
                    model: {
                      value: _vm.qty,
                      callback: function($$v) {
                        _vm.qty = $$v
                      },
                      expression: "qty"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "o-btn o-btn--filled o-btn--expand",
                      on: {
                        click: function($event) {
                          return _vm.addToCart()
                        }
                      }
                    },
                    [_c("div", [_vm._v("Add to inquiry")])]
                  )
                ],
                2
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.showModal
                  ? _c("div", {
                      staticClass: "o-addtocartmodal__bg",
                      on: {
                        click: function($event) {
                          return _vm.closeModal()
                        }
                      }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.showModal
                  ? _c("div", { staticClass: "o-addtocartmodal" }, [
                      _vm.addingToCart
                        ? _c(
                            "div",
                            { staticClass: "o-addtocartmodal__loader" },
                            [_vm._t("loader")],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "o-addtocartmodal__close",
                          on: {
                            click: function($event) {
                              return _vm.closeModal()
                            }
                          }
                        },
                        [_c("img", { attrs: { src: "/images/close.svg" } })]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "o-addtocartmodal__header" }, [
                        _c("img", { attrs: { src: "/images/success.svg" } }),
                        _vm._v(
                          "\n            Product successfully added to inquiry list\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "o-addtocartmodal__data" }, [
                        _c(
                          "div",
                          { staticClass: "o-addtocartmodal__data-left" },
                          [
                            _c("img", {
                              attrs: { src: _vm.selectedVariation.imageXl.url }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "o-addtocartmodal__data-right" },
                          [
                            _c("div", { staticClass: "title" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.title) +
                                  "\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "description" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.description) +
                                  "\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "variation valueLabel" }, [
                              _c("div", { staticClass: "label" }, [
                                _vm._v("Variant:")
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.selectedVariation.title) +
                                    "\n                "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "qty valueLabel" }, [
                              _c("div", { staticClass: "label" }, [
                                _vm._v("Quantity:")
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.qty) +
                                    "\n                "
                                )
                              ])
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "o-addtocartmodal__buttons" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "o-btn o-addtocartmodal__buttons__continue",
                            on: {
                              click: function($event) {
                                return _vm.closeModal()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              Continue shopping\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "o-btn o-btn--filled",
                            attrs: { href: _vm.carturl }
                          },
                          [_vm._v("Proceed to inquiry list")]
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "l-product__ctas" }, [_vm._t("cta")], 2)
        ],
        2
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade", mode: "in-out" } }, [
        _vm.showFullsize
          ? _c(
              "div",
              {
                staticClass: "c-product__fullsize",
                attrs: { tabindex: "0" },
                on: {
                  keydown: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "esc", 27, $event.key, [
                        "Esc",
                        "Escape"
                      ])
                    ) {
                      return null
                    }
                    return _vm.closeLargeImage($event)
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "close", on: { click: _vm.closeLargeImage } },
                  [
                    _c("svg", { attrs: { viewBox: "0 0 200 200" } }, [
                      _c("path", {
                        staticClass: "cls-1",
                        attrs: {
                          d:
                            "M156.1377,106.5757H43.8389a5.5,5.5,0,0,1,0-11H156.1377a5.5,5.5,0,0,1,0,11Z"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        staticClass: "cls-1",
                        attrs: {
                          d:
                            "M99.9883,162.7251a5.5006,5.5006,0,0,1-5.5-5.5V44.9262a5.5,5.5,0,0,1,11,0V157.2251A5.5006,5.5006,0,0,1,99.9883,162.7251Z"
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.selectedVariation
                  ? _c(
                      "swiper",
                      {
                        ref: "fullsizeSwiper",
                        staticClass: "swiper fullsizeSwiper",
                        attrs: { options: _vm.fullsizeSwiper },
                        on: { swiper: _vm.setLargeSwiper }
                      },
                      [
                        _vm._l(_vm.selectedVariation.slides, function(
                          slide,
                          index
                        ) {
                          return _c(
                            "swiper-slide",
                            { key: index, staticClass: "fullsizeSwiper-slide" },
                            [
                              _c("img", {
                                attrs: {
                                  src: "placeholder",
                                  srcset: slide.xlarge,
                                  alt: slide.alt
                                }
                              })
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "fullsize-swiper-prev swiper-button-prev",
                            attrs: { slot: "button-prev" },
                            slot: "button-prev"
                          },
                          [_vm._t("prevbuttonsvg")],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "fullsize-swiper-next swiper-button-next",
                            attrs: { slot: "button-next" },
                            slot: "button-next"
                          },
                          [_vm._t("nextbuttonsvg")],
                          2
                        )
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "fullsizeThumbsSwiper__wrapper" },
                  [
                    _vm.selectedVariation
                      ? _c(
                          "swiper",
                          {
                            ref: "fullsizeThumbsSwiper",
                            staticClass: "swiper fullsizeThumbsSwiper",
                            attrs: { options: _vm.fullsizeThumbsSwiper }
                          },
                          _vm._l(_vm.selectedVariation.slides, function(
                            thumb,
                            index
                          ) {
                            return _c(
                              "swiper-slide",
                              {
                                key: index,
                                staticClass: "fullsizeThumbsSwiper-slide"
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: _vm.placeholder,
                                    srcset: thumb.thumb,
                                    alt: thumb.alt
                                  }
                                })
                              ]
                            )
                          }),
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }